import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const vehicleGroupFilterSchema = z.object({
	search: optionalFilterString,
});
